import { render, staticRenderFns } from "./itemListMarketTopComponent.vue?vue&type=template&id=7ae721e2&scoped=true"
import script from "./itemListMarketTopComponent.vue?vue&type=script&lang=js"
export * from "./itemListMarketTopComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ae721e2",
  null
  
)

export default component.exports